import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { notifyError, notifySuccess } from "../../utils/Notification";
import { isPhone } from "../../utils/PlatformHelper";
import { getAvailabelTestDates, setTestDate } from "./Api";

import 'react-calendar/dist/Calendar.css'
import './ExamCalendar.css'
import Calendar from 'react-calendar'

import { format } from "date-fns"
import { RiLoader5Fill } from "react-icons/ri";
import { setIsHomeProcess } from "../../app/GlobalSlice";
import { logout } from "../../app/Api";
import { useNavigate } from "react-router";

const ScheduleTestPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { member, systemProfile, screenSize } = useSelector(state => state.global)

  const [testDates, setTestDates] = useState([])

  const [selectedDate, setSelectedDate] = useState(null)

  const [activeStartDate, setActiveStartDate] = useState(null)

  const [hashImage, setHashImage] = useState(Date.now());

  const [isLoadData, setIsLoadData] = useState(false)

  useEffect(() => {
    setIsLoadData(true)

    getAvailabelTestDates()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setTestDates(payload)
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => {
        setIsLoadData(false)
      })

  }, [])

  function onSave() {
    // console.log(selectedDate)
    if (!selectedDate && !testDates.find(d => d === format(selectedDate, "dd/MM/yyyy"))) 
      return notifyError('Tanggal dipilih tidak tersedia')

    const payload = {
      testDate: format(selectedDate, "yyyy-MM-dd")
    }

    dispatch(setIsHomeProcess(true))

    setTestDate(payload)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Tanggal Ujian berhasil disimpan')
            navigate('/home/document')
          },
          onRecovFailure: errors => errors.forEach(err => {
            notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
            notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => {
        dispatch(setIsHomeProcess(false))
      })

  }

  function onLogout() {
    dispatch(setIsHomeProcess(true))

    logout()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Logout Berhasil')
            navigate("/login")
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => { dispatch(setIsHomeProcess(false)) })
  }

  return (
    <div
      className="h-screen"
    >
      <div
        className="py-10 flex flex-col items-center justify-center space-y-3"
      >
        <div
          className="relative rounded-sm bg-white"
          style={{
            width: isPhone(screenSize.width) ? '100%' : '650px'
          }}
        >

          <div
            className="py-5 pt-8 text-center uppercase font-bold" 
            style={{
              fontFamily: 'Nunito',
              fontSize: '20px'
            }}
          >
            <label>Atur Jadwal Ujian</label>
          </div>
          <div
            className="flex justify-center py-5"
          >
            <img src={systemProfile.companyLogo + '?' + hashImage} width={'150px'}/>
          </div>
          <div
            className="border-t border-b"
          >
            <div
              className="py-5 border-t border-b px-8 bg-blue-100 space-y-2"
            >
              <div
                className="font-bold text-center uppercase"
                style={{
                  fontFamily: 'Nunito',
                  fontSize: '18px'
                }}
              >
                Informasi
              </div>
              <div
                className="text-center"
                style={{
                  fontSize: '14px'
                }}
              >
                <ul className="text-left space-y-1">
                  <li className="p-0">
                    Silahkan pilih salah satu tanggal ujian yang tersedia     
                  </li>
                  <li className="p-0">
                    Tanggal ujian ditandai dengan warna khusus
                  </li>
                  <li className="p-0">
                    Anda dapat meminta tanggal ujian di luar tanggal yang disediakan dengan menghubungi Customer Service kami
                  </li>
                </ul>
              </div>

            </div>
            <div className="px-8 py-5">
              <div className="relative flex justify-center">
                <Calendar
                  className="shadow-lg border-gray-200 rounded-lg p-2"
                  onChange={setSelectedDate}
                  value={selectedDate}
                  tileClassName={({ date, view }) => {
                    return testDates.find(d => d == format(date, "yyyy-MM-dd")) ?
                      ' marked '
                      :
                      ' '
                  }}
                  // onClickYear={d => setSelectedYear(d.getFullYear())}
                  locale={"id-ID"}
                  onActiveStartDateChange={date => setActiveStartDate(date.activeStartDate)}
                />
                {isLoadData && (
                  <>
                  <div className="absolute left-0 right-0 top-0 bottom-0 z-[5] bg-gray-300 rounded-lg opacity-50"/>
                  <div className="absolute left-0 right-0 top-0 bottom-0 z-[6] flex items-center justify-center">
                    <RiLoader5Fill className="h-10 w-10 text-blue-600 animate-spin"/>
                  </div>
                  </>
                )}

              </div>
            </div>
            <div className="flex justify-center">
              <div className="w-[400px] border border-gray-300 p-2 rounded-md">
                <div style={{ fontSize: '14px' }}>
                  <div>
                    Tanggal ujian dipilih :
                  </div>
                  <div>
                    { selectedDate ? format(selectedDate, "dd/MM/yyy") : '-' }
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center py-3">
              <div className="w-[400px]">
                <button
                  className="w-full p-1.5 bg-blue-500 text-white rounded-ld"
                  onClick={onSave}
                >
                  Simpan 
                </button>
              </div>
            </div>
        
          </div>
          <div
            className="py-5 flex justify-center border-t"
          >
            <div
              className="w-2/3 px-10 space-y-5"
            >
              <button
                className="w-full border border-blue-500 py-1.5 rounded-md hover:bg-blue-500 hover:text-white"
                style={{
                  fontSize: '14px'
                }}
                onClick={onLogout}
              >
                Keluar
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  )

}

export default ScheduleTestPage;